import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';

const EliminarFlujoDialog = ({
  open,
  flowToDelete,
  onClose,
  onConfirmDelete
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "#e11d48",
          fontWeight: 800,
          fontSize: 22,
          pt: 3,
          px: 3,
          letterSpacing: 1,
        }}
      >
        <span role="img" aria-label="Eliminar">🗑️</span>
        Eliminar flujo
      </DialogTitle>
      
      <DialogContent sx={{ pt: 1, px: 3, pb: 0 }}>
        <Box sx={{ color: "#334155", fontWeight: 500, fontSize: 15 }}>
          ¿Seguro que deseas eliminar el flujo <b>{flowToDelete?.name}</b>?<br />
          Esta acción no se puede deshacer.
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2, pt: 2 }}>
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            borderColor: "#e0e7ef",
            color: "#334155",
            background: "#fff",
            "&:hover": { background: "#f1f5f9", borderColor: "#6366f1", color: "#6366f1" }
          }}
        >
          Cancelar
        </Button>
        
        <Button
          onClick={onConfirmDelete}
          color="error"
          variant="contained"
          sx={{
            borderRadius: 2,
            fontWeight: 700,
            background: "#e11d48",
            color: "#fff",
            boxShadow: "none",
            "&:hover": { background: "#b91c1c", color: "#fff" }
          }}
          startIcon={<span role="img" aria-label="Eliminar">🗑️</span>}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EliminarFlujoDialog;